module.exports = __webpack_public_path__ + "brilla-logo.png";